export default function Steps({ step = 1 }) {
  return (
    <nav className="flex items-center" aria-label="Progress">
      <p className="text-xs font-medium text-gray-500">Step {step} of 2</p>
    </nav>
  );
}
